module.exports = __webpack_public_path__ + "static/media/madfit-1.67d11bb7.jpg";